import { render, staticRenderFns } from "./SingleWork.vue?vue&type=template&id=46b54778&scoped=true&"
import script from "./SingleWork.vue?vue&type=script&lang=js&"
export * from "./SingleWork.vue?vue&type=script&lang=js&"
import style0 from "./SingleWork.vue?vue&type=style&index=0&id=46b54778&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b54778",
  null
  
)

export default component.exports